import { createFileRoute } from "@tanstack/react-router";

import NotFoundPage from "@/components/NotFoundPage";

export const Route = createFileRoute("/_app/_dashboard/404")({
  component: NotFoundPage,
});
